import { defineMessages } from 'react-intl';

export default defineMessages({
    chooseHeatingType: {
        id: 'quoteandbind.eh.views.component.coolingsystem.Cooling Type',
        defaultMessage: 'Cooling Type',
    },
    isPrimaryYes: {
        id: 'quoteandbind.eh.views.component.coolingsystem.isPrimary.Yes',
        defaultMessage: 'Yes',
    },
    isPrimaryNo: {
        id: 'quoteandbind.eh.views.component.coolingsystem.isPrimary.No',
        defaultMessage: 'No',
    }
});
